import { Text } from "../../../../components/texts/text";
import { _colorText, _sizeText } from "../../../../core/core";
import { useDeviceScreen } from "../../../../hooks/useDeviceScreen";
import "./DiscontBanner.css";



export const DiscontBanner = () => {
    const { isDesktop } = useDeviceScreen();
    if (!isDesktop) return null;

    return (
        <div className="discont-banner">
            <Text size={_sizeText.xlb} color={_colorText.black}>Скидка 15% на первый заказ</Text>
            <img src={'/static/hm/images/discont-banner.webp'} alt="discont-banner" />
        </div>
    )
}